/* Here, there are some custom plug-ins.
 * Developed for ASP.NET Iteration Zero (http://aspnetzero.com). */
(function ($) {
    if (!$) {
        return;
    }

    /* A simple jQuery plug-in to make a button busy. */
    $.fn.buttonBusy = function (isBusy) {
        return this.each(function () {
            const $button = $(this);
            const $icon = $button.find("i");
            const $buttonInnerSpan = $button.find("span");

            if (isBusy) {
                if ($button.hasClass("button-busy")) {
                    return;
                }

                $button.attr("disabled", "disabled");

                //change icon
                if ($icon.length) {
                    $button.data("iconOriginalClasses", $icon.attr("class"));
                    $icon.removeClass();
                    $icon.addClass("fa fa-spin fa-spinner");
                }

                //change text
                if ($buttonInnerSpan.length && $button.attr("busy-text")) {
                    $button.data("buttonOriginalText", $buttonInnerSpan.html());
                    $buttonInnerSpan.html($button.attr("busy-text"));
                }

                $button.addClass("button-busy");
            } else {
                if (!$button.hasClass("button-busy")) {
                    return;
                }

                //enable button
                $button.removeAttr("disabled");

                //restore icon
                if ($icon.length && $button.data("iconOriginalClasses")) {
                    $icon.removeClass();
                    $icon.addClass($button.data("iconOriginalClasses"));
                }

                //restore text
                if ($buttonInnerSpan.length && $button.data("buttonOriginalText")) {
                    $buttonInnerSpan.html($button.data("buttonOriginalText"));
                }

                $button.removeClass("button-busy");
            }
        });
    };

    $.fn.serializeFormToObject = function (options, keysToExcludeFromCamelization) {
        if (!this.length) {
            return null;
        }

        const defaultOptions = {
            useIntKeysAsArrayIndex: true,
            customTypes: {
                nullableNumber: (strVal, el) => {
                    if (strVal === "" || strVal === null || strVal === undefined || Number.isNaN(strVal)) {
                        return null;
                    }

                    return parseFloat(strVal);
                },
                nullableBoolean: (strVal, el) => {
                    if (strVal === "" || strVal === null || strVal === undefined) {
                        return null;
                    }

                    const normalizedVal = strVal.toLowerCase();
                    let result = null;
                    switch (normalizedVal) {
                        case "true":
                            result = true;
                            break;

                        case "false":
                            result = false;
                            break;
                    }

                    return result;
                },
                string: (strVal, el) => {
                    return strVal || null;
                },
                bitwiseBoolean: (strVal, el) => {
                    const $container = $(el).closest(".bitwise-boolean-container");
                    const index = $('[data-value-type="bitwiseBoolean"]', $container).index(el);

                    if (index == 0) {
                        // first element in the container
                        $container.data("value", 0);
                    }

                    if ($(el).is(":checked")) {
                        $container.data("value", $container.data("value") | $(el).val());
                    }

                    const value = $container.data("value");
                    if (!value) {
                        return null;
                    }

                    return value;
                },
                tempusDominus: (strVal, el) => {
                    if (strVal) {
                        const $element = $(el).closest(".tempus-dominus");
                        if ($element.is('[data-td-custom-type="date-picker"]')) {
                            if ($element.is('[data-td-custom-mode="as-utc"]')) {
                                return abp.dateTimeFormatter.formatAsUtcFromShortDate(strVal);
                            }

                            return abp.dateTimeFormatter.formatUtcFromShortDate(strVal);
                        } else if ($element.is('[data-td-custom-type="time-picker"]')) {
                            let time = $element.is('[data-td-custom-mode="as-utc"]')
                                ? abp.dateTimeFormatter.formatAsUtcFromShortTime(strVal)
                                : abp.dateTimeFormatter.formatUtcFromShortTime(strVal);

                            if (time) {
                                time = window.moment(time, "THH:mm:ssZ", true).utcOffset(0).format("HH:mm:ss");
                            }

                            return time;
                        } else if ($element.is('[data-td-custom-type="datetime-picker"]')) {
                            if ($element.is('[data-td-custom-mode="as-utc"]')) {
                                return abp.dateTimeFormatter.formatAsUtcFromShortDateShortTime(strVal);
                            }

                            return abp.dateTimeFormatter.formatUtcFromShortDateShortTime(strVal);
                        } else if ($element.is('[data-td-custom-type="year-picker"]')) {
                            return `${strVal}-01-01`;
                        } else if ($element.is('[data-td-custom-type="month-picker"]')) {
                            return `${strVal}-01`;
                        }
                    }

                    return null;
                },
                iti: (strVal, el) => {
                    const iti = $(el).intlTelInput();
                    if (iti === null || !iti.isValidNumber()) {
                        return null;
                    }

                    return `${iti.getNumber()}${(iti.getExtension() ? ` ext. ${iti.getExtension()}` : "")}`;
                },
                authCode: (strVal, el) => {
                    const $container = $(el).parent();
                    const index = $('[data-value-type="authCode"]', $container).index(el);

                    if (index == 0) {
                        // first element in the container
                        $container.data("value", "");
                    }

                    $container.data("value", `${$container.data("value")}${$(el).val()}`);

                    const value = $container.data("value");
                    if (!value) {
                        return null;
                    }

                    return value;
                }
            }
        };
        options = $.extend(true, {}, defaultOptions, options);

        keysToExcludeFromCamelization = keysToExcludeFromCamelization || [];
        keysToExcludeFromCamelization = _.union(keysToExcludeFromCamelization, ["__RequestVerificationToken"]);

        const $form = this;
        if (!$form.is("form")) {
            throw "Expected a form element.";
        }

        // Set default data-value-type for each elements in the form
        $("input:checkbox", $form).each(function () {
            const $element = $(this);

            let attr = $element.attr("data-value-type");
            if (typeof (attr) === "undefined" || attr === false || attr === "false") {
                $element.attr("data-value-type", "boolean");
            }

            attr = $element.attr("data-no-unchecked-value");
            if (typeof (attr) === "undefined" || attr === false || attr === "false") {
                attr = $element.attr("data-unchecked-value");
                if (typeof (attr) === "undefined" || attr === false || attr === "false") {
                    $element.attr("data-unchecked-value", "false");
                }
            } else {
                $element.removeAttr("data-unchecked-value");
            }
        });
        $('input[type="number"]', $form).each(function () {
            const attr = $(this).attr("data-value-type");

            if (typeof (attr) === "undefined" || attr === false || attr === "false") {
                $(this).attr("data-value-type", "nullableNumber");
            }
        });
        $("select", $form).each(function () {
            const attr = $(this).attr("data-value-type");

            if (typeof (attr) === "undefined" || attr === false || attr === "false") {
                $(this).attr("data-value-type", "null");
            }
        });
        $(".tempus-dominus", $form).each(function () {
            const $td = $('input[type="text"], input[type="search"]', this);
            const attr = $td.attr("data-value-type");

            if (typeof (attr) === "undefined" || attr === false || attr === "false") {
                $td.attr("data-value-type", "tempusDominus");
            }
        });
        $('input.iti__tel-input', $form).each(function () {
            const attr = $(this).attr("data-value-type");

            if (typeof (attr) === "undefined" || attr === false || attr === "false") {
                $(this).attr("data-value-type", "iti");
            }
        });
        $(".query-builder, .datatable-container", $form).each(function () {
            const $elements = $('input[name], select[name]', this);
            $elements.attr("data-value-type", "skip");
        });
        $(".query-builder, .datatable-container, .input-spinner-container+input", $form).each(function () {
            $(this).attr("data-value-type", "skip");
        });

        // Remove duplicate inputs from the form, most commonly due to ASP.NET MVC adding an additional "hidden" input with value of "false"
        // for checkbox input. Web browsers will not post unchecked checkbox to server. By adding this hidden input, the value of "false"
        // will still be sent to server even when the checkbox is not checked.
        // We do not need this additional hidden input when the form is submitted using AJAX and the hidden input will only mess with jQuery.serializeJSON plugin
        // because the plugin will always take the last input with the same name.
        $('input[name][type="hidden"]', $form).each(function () {
            if ($(`input[name="${$(this).attr("name")}"][type="checkbox"]`, $form).length > 0) {
                // duplicate control, therefore remove it
                $(this).remove();
            } else {
                // https://github.com/dotnet/aspnetcore/issues/4942
                const alternateName = $(this).attr("name").replace(/\./g, "][").replace("][", "[").concat("]");
                if ($(`input[name="${alternateName}"][type="checkbox"]`, $form).length > 0) {
                    // duplicate control, therefore remove it
                    $(this).remove();
                }
            }
        });

        const fields = $form.find("[disabled]");
        fields.prop("disabled", false);
        let json = $form.serializeJSON(options);
        fields.prop("disabled", true);

        json = app.camelizeKeys(json, keysToExcludeFromCamelization);
        return json;
    };

    $.fn.intlTelInput = function (options) {
        const $elements = this;
        if (!$elements.length) {
            return null;
        }

        const results = [];
        $elements.each(function () {
            const input = this;

            var iti = window.intlTelInput.getInstance(input);
            if (iti) {
                results.push(iti);
                return;
            }

            const opts = {
                dropdownContainer: input.closest(".modal, body"),
                separateDialCode: true,
                nationalMode: false,
                //utilsScript: "/lib/intl-tel-input/build/js/utils.js",
                initialCountry: "auto",
                autoPlaceholder: "off",
                geoIpLookup: function (success, failure) {
                    fetch("https://ipapi.co/json")
                        .then(function (res) { return res.json(); })
                        .then(function (data) { success(data.country_code); })
                        .catch(function () { failure(); });
                }
            };

            const $input = $(input);
            if ($input.data("auto-placeholder")) {
                opts.autoPlaceholder = $input.data("auto-placeholder");
            }

            if ($input.data("hidden-input")) {
                opts.hiddenInput = $input.data("hidden-input");
            }

            if ($input.data("only-countries")) {
                opts.onlyCountries = $input.data("only-countries").split(",");
            }

            if ($input.data("country-order")) {
                opts.countryOrder = $input.data("country-order").split(",");
            }

            $.extend(opts, options);

            if (!opts.countryOrder) {
                opts.countryOrder = [];
            }

            iti = window.intlTelInput(input, opts);

            // This function is copied over from intl-tel-input codes and changed just a line.
            //* When the input is in a hidden container during initialisation, we must inject some markup
            //* into the end of the DOM to calculate the correct offsetWidth.
            //* NOTE: this is only used when separateDialCode is enabled, so countryContainer and selectedCountry
            //* will definitely exist.
            iti._getHiddenSelectedCountryWidth = function () {
                if (this.telInput.parentNode) {
                    const containerClone = this.telInput.parentNode.cloneNode(false);
                    containerClone.style.visibility = "hidden";
                    document.body.appendChild(containerClone);
                    const countryContainerClone = this.countryContainer.cloneNode();
                    containerClone.appendChild(countryContainerClone);
                    const selectedCountryClone = this.selectedCountry.cloneNode(true);
                    countryContainerClone.appendChild(selectedCountryClone);
                    const width = selectedCountryClone.offsetWidth;
                    document.body.removeChild(containerClone);
                    return width + 8; // add another 8px to adjust for the left padding
                }

                return 0;
            }

            if (iti.selectedCountryData && !_.isEmpty(iti.selectedCountryData)) {
                // reselect country to set the left padding of the input so that the _getHiddenSelectedCountryWidth() function set above can be called.
                // _getHiddenSelectedCountryWidth() is set after "iti" was initialized, that is why we call it again.
                iti._setCountry(iti.selectedCountryData.iso2);

                const $selectedItem = $(`.iti__country[data-country-code="${iti.selectedCountryData.iso2}"]`, iti.countryList);
                $selectedItem.addClass("iti__active");
                iti.selectedItem = $selectedItem.get(0);
            }

            // #region Country selected event

            iti._selectListItem = (function () {
                const original = iti._selectListItem;
                return function (listItem) {
                    if (iti.selectedItem) {
                        $(iti.selectedItem).removeClass("iti__active");
                    }

                    original.call(this, listItem);

                    iti.selectedItem = listItem;
                    $(listItem).addClass("iti__active");
                };
            })();

            // #endregion

            // #region Add Copy-to-Clipoard button

            const $inputGroup = $input.closest(".iti").addClass("input-group");

            const $inputGroupAppend = $('<div class="input-group-append"></div>').appendTo($inputGroup);
            const $copyButton = $(`<button type="button" class="copy-btn btn btn-s btn-light-info"><i class="far fa-copy"></i></button>`).appendTo($inputGroupAppend);

            $copyButton.copyToClipboard({
                text: function (trigger) {
                    return `${iti.getNumber()}${(iti.getExtension() ? ` ext. ${iti.getExtension()}` : "")}`;
                }
            });

            // #endregion

            results.push(iti);
        });

        if (results.length === 1) {
            return results[0];
        } else {
            return results;
        }
    };

    $.fn.copyToClipboard = function (options) {
        if (!this.length) {
            return null;
        }

        if (typeof (options) === "string" || options instanceof window.jQuery) {
            options = {
                targetInput: options
            };
        }

        var settings = $.extend({
            tooltipText: app.localize("CopyToClipboard"),
            tooltipSuccessText: app.localize("CopyToClipboardSuccess"),
            tooltipFailedText: app.localize("CopyToClipboardFailed")
        }, options);

        const $triggerElements = settings.trigger ? $(settings.trigger) : this;

        if ($triggerElements.data("toggle") !== "tooltip") {
            $triggerElements.attr("title", settings.tooltipText);
            $triggerElements.tooltip({
                template: '<div class="tooltip tooltip-dark" role="tooltip">\
                    <div class="arrow"></div>\
                    <div class="tooltip-inner"></div>\
                </div>'
            });
        }

        const clipboardOptions = {};
        if (settings.targetInput) {
            clipboardOptions.target = function (trigger) {
                return $(settings.targetInput).get(0);
            };
        } else if (settings.target) {
            clipboardOptions.target = settings.target;
        } else if (settings.text) {
            clipboardOptions.text = settings.text;
        }/* else if ($triggerElements.get(0).hasAttribute('data-clipboard-text')) {
            clipboardOptions.text = function (trigger) {
                return trigger.getAttribute('data-clipboard-text');
            };
        } else {
            clipboardOptions.target = function (trigger) {
                return trigger;
            };
        }*/

        const $modal = $triggerElements.closest(".modal");
        if ($modal.length) {
            clipboardOptions.container = $modal.get(0);
        }

        const clipboard = new window.ClipboardJS($triggerElements.toNodeList(), clipboardOptions);

        clipboard.on("success", function (e) {
            displayMessage(e.trigger, settings.tooltipSuccessText, settings.tooltipText);

            e.clearSelection();
        });

        clipboard.on("error", function (e) {
            displayMessage(e.trigger, settings.tooltipFailedText, settings.tooltipText);
        });

        function displayMessage(triggerElement, message, originalMessage) {
            $(triggerElement)
                .one("shown.bs.tooltip", function () {
                    $(this).attr("data-original-title", originalMessage);
                })
                .attr("data-original-title", message)
                .tooltip("show");
        }

        return $triggerElements;
    };

    $.fn.notification = function (title, message, icon, titleClass, messageClass, callback, options) {
        const $elements = this;
        if (!$elements.length) {
            return $elements;
        }

        const $element = $($elements.get(0));

        setTimeout(function () {
            $element.tooltip("hide");
        });

        // close existing popover that is opened
        const popoverId = $element.data("popover-id");
        if (popoverId) {
            $element.removeData("popover-id");

            const $popover = $(`#${popoverId}`);
            if ($popover.length > 0) {
                setTimeout(function () {
                    $element.popover("hide");
                });
                return $element;
            }
        }
        const activePopover = $(document).data("active-popover");
        if (activePopover) {
            $(activePopover).popover("hide");
        }

        options = $.extend({
            html: true,
            container: $("body").get(0),

            // prevent the modal that this popover is in (if any) from closing when pressing the ESC key. The ESC key will close this popover without also
            // closing the modal. Only after this popover is close, subsequent ESC key press will close the modal.
            preventModalClose: true
        }, options);

        const originalTitle = $element.data("original-title");
        if (title) {
            // if element has data-original-title attribute, it will be prioritized and shown.
            // this data-original-title attribute could be used by tooltip.
            // therefore remove it so that 'title' can be shown instead.
            if (originalTitle) {
                $element.removeAttr("data-original-title");
            }

            const $titleContainer = $("<span />");

            if (icon) {
                const $icon = $(`<i class="mr-2 ${icon}"></i>`).appendTo($titleContainer);
                if (titleClass) {
                    $icon.addClass(titleClass);
                }
            }
            const $titleText = $(`<span>${title}</span>`).appendTo($titleContainer);
            if (titleClass) {
                $titleText.addClass(titleClass);
            }

            options.title = $titleContainer.get(0);
        }

        const $message = $(`<div>${message}</div>`);
        if (messageClass) {
            $message.addClass(messageClass);
        }
        options.content = $message.get(0);

        let documentKeydown;
        let documentClick;
        $element.one("shown.bs.popover", function () {
            if (title) {
                // restore data-original-title attribute, after the popover is shown.
                // this data-original-title attribute could be used by tooltip.
                if (originalTitle) {
                    $element.attr("data-original-title", originalTitle);
                }
            }

            // prevents popover from closing if clicked inside the popover.
            let preventClose = false;
            const $popover = $(".popover", options.container).last();
            if ($popover.length > 0) {
                $element.data("popover-id", $popover.attr("id"));
                $(document).data("active-popover", $element.get(0));

                $popover.on("click", function (e) {
                    preventClose = true;
                });
            }

            // closes the popover when ESC is pressed.
            documentKeydown = function (e) {
                if (e.which === 27) {
                    $element.popover("hide");
                    $element.focus();
                }
            };
            setTimeout(function () {
                $(document).on("keydown", documentKeydown);
            });

            // Closes popover when any element outside of the popover receives focus or clicked.
            documentClick = function (e) {
                if ($popover.length > 0) {
                    if (!$.contains($element.get(0), e.target) && !preventClose) {
                        $element.popover("hide");
                    } else {
                        preventClose = false;
                    }
                }
            };
            setTimeout(function () {
                $(document).on("click", documentClick);
            });

            $message.focus();
        });

        $element.one("hide.bs.popover", function () {
            if (options.preventModalClose) {
                // allows the modal that the element is in to close after the popover is hidden.
                $(this).closest(".modal").removeData("prevent-close");
            }
        });

        $element.one("hidden.bs.popover", function () {
            $(this).removeData("popover-id");
            $(document).removeData("active-popover");

            $(document).off("keydown", documentKeydown);
            $(document).off("click", documentClick);

            setTimeout(function () {
                $element.popover("dispose");
            });

            if (callback) {
                callback.call(this, false);
            }
        });

        if (options.preventModalClose) {
            // prevents the modal that the element is in from closing when the popover is shown.
            $element.closest(".modal").data("prevent-close", true);
        }

        $element.popover(options);

        if (options.trigger !== "manual") {
            $element.popover("show");
        }

        return $element;
    };

    $.fn.confirmation = function (title, message, callback, options) {
        const $elements = this;
        if (!$elements.length) {
            return $elements;
        }

        const $element = $($elements.get(0));

        setTimeout(function () {
            $element.tooltip("hide");
        });

        // close existing popover that is opened
        const popoverId = $element.data("popover-id");
        if (popoverId) {
            $element.removeData("popover-id");

            const $popover = $(`#${popoverId}`);
            if ($popover.length > 0) {
                setTimeout(function () {
                    $element.popover("hide");
                });
                return $element;
            }
        }
        const activePopover = $(document).data("active-popover");
        if (activePopover) {
            $(activePopover).popover("hide");
        }

        options = $.extend({
            html: true,
            container: $("body").get(0),

            // prevent the modal that this popover is in (if any) from closing when pressing the ESC key. The ESC key will close this popover without also
            // closing the modal. Only after this popover is close, subsequent ESC key press will close the modal.
            preventModalClose: true
        }, options);

        const originalTitle = $element.data("original-title");
        if (title) {
            // if element has data-original-title attribute, it will be prioritized and shown.
            // this data-original-title attribute could be used by tooltip.
            // therefore remove it so that 'title' can be shown instead.
            if (originalTitle) {
                $element.removeAttr("data-original-title");
            }

            const $titleContainer = $("<span />");

            $('<i class="mr-2 fas fa-question-circle text-primary"></i>').appendTo($titleContainer);

            $(`<span>${title}</span>`).appendTo($titleContainer).addClass("text-primary");

            options.title = $titleContainer.get(0);
        }

        const $messageContainer = $("<div />");
        if (message) {
            const $message = $('<div class="mb-3" />').appendTo($messageContainer);
            $message.append(message);
        }

        let callbackCalled = false;
        const $noButton = $('<button type="button">')
            .addClass("btn btn-sm btn-light-danger")
            .append('<i class="fas fa-times"></i>')
            .append(`<span>${app.localize("No")}</span>`)
            .click(function () {
                $element.popover("hide");
                $element.focus();

                if (callback) {
                    callback.call($element.get(0), false);
                    callbackCalled = true;
                }
            });

        const $yesButton = $('<button type="button">')
            .addClass("btn btn-sm btn-light-success")
            .append('<i class="fas fa-check"></i>')
            .append(`<span>${app.localize("Yes")}</span>`)
            .click(function () {
                $element.popover("hide");
                $element.focus();

                if (callback) {
                    callback.call($element.get(0), true);
                    callbackCalled = true;
                }
            });

        const $buttonContainer = $('<div class="d-flex justify-content-end" />')
            .append($noButton)
            .append($yesButton);

        $messageContainer.append($buttonContainer);
        options.content = $messageContainer;

        let documentKeydown;
        let documentClick;
        $element.one("shown.bs.popover", function () {
            if (title) {
                // restore data-original-title attribute, after the popover is shown.
                // this data-original-title attribute could be used by tooltip.
                if (originalTitle) {
                    $element.attr("data-original-title", originalTitle);
                }
            }

            // prevents popover from closing if clicked inside the popover.
            let preventClose = false;
            const $popover = $(".popover", options.container).last();

            if ($popover.length > 0) {
                $element.data("popover-id", $popover.attr("id"));
                $(document).data("active-popover", $element.get(0));

                $popover.on("click", function (e) {
                    preventClose = true;
                });
            }

            // closes the popover when ESC is pressed.
            documentKeydown = function (e) {
                if (e.which === 27) {
                    $element.popover("hide");
                    $element.focus();
                }
            };
            setTimeout(function () {
                $(document).on("keydown", documentKeydown);
            });

            // Closes popover when any element outside of the popover receives focus or clicked.
            documentClick = function (e) {
                if ($popover.length > 0) {
                    if (!$.contains($element.get(0), e.target) && !preventClose) {
                        $element.popover("hide");
                    } else {
                        preventClose = false;
                    }
                }
            };
            setTimeout(function () {
                $(document).on("click", documentClick);
            });

            $noButton.focus();
        });

        $element.one("hide.bs.popover", function () {
            if (options.preventModalClose) {
                // allows the modal that the element is in to close after the popover is hidden.
                $(this).closest(".modal").removeData("prevent-close");
            }
        });

        $element.one("hidden.bs.popover", function () {
            $(this).removeData("popover-id");
            $(document).removeData("active-popover");
            $(document).off("keydown", documentKeydown);
            $(document).off("click", documentClick);

            setTimeout(function () {
                $element.popover("dispose");
            });

            if (!callbackCalled && callback) {
                callback.call(this, false);
            }
        });

        if (options.preventModalClose) {
            // prevents the modal that the element is in from closing when the popover is shown.
            $element.closest(".modal").data("prevent-close", true);
        }

        $element.popover(options);

        if (options.trigger !== "manual") {
            $element.popover("show");
        }

        return $element;
    };

    $.fn.hasInlineCss = function (style) {
        if (!this.length) {
            return null;
        }

        const $element = this.first();

        // jQuery's .css() returns styles from both inline and css class,
        // we're only interested in knowing if the element has inline style.
        // to check if an element has inline style, remove the style and compare the value before and after removing,
        // if they are the same, assume there's no inline style.
        const styleBeforeRemoved = $element.css(style);
        $element.css(style, ""); // remove style
        const styleAfterRemoved = $element.css(style);

        const result = styleBeforeRemoved !== styleAfterRemoved;

        if (result) {
            $element.css(style, styleBeforeRemoved);
        }

        return result;
    };

    $.fn.toNodeList = function () {
        if (!this.length) {
            return null;
        }

        const tagAttribute = "data-tag-for-query";
        this.each(function () {
            $(this).attr(tagAttribute, "true");
        });

        const nodes = document.querySelectorAll(`[${tagAttribute}="true"]`);

        Array.prototype.forEach.call(nodes, function (node) {
            $(node).removeAttr(tagAttribute);
        });

        return nodes;
    };

    $.fn.perfectScrollbar = function (options) {
        const $containers = this;
        if (!$containers.length) {
            return null;
        }

        const results = [];
        $containers.addClass("scroll");
        $containers.each(function () {
            const container = this;
            const $container = $(container);

            let ps = $container.data("perfect-scrollbar");
            if (ps) {
                results.push(ps);
                return;
            }

            if (options) {
                ps = new window.PerfectScrollbar(container, options);
            } else {
                ps = new window.PerfectScrollbar(container);
            }

            $container.data("perfect-scrollbar", ps);

            ps.destroy = (function () {
                var original = ps.destroy;
                return function () {
                    $container.removeData("perfect-scrollbar");
                    return original.apply(arguments);
                };
            })();

            results.push(ps);
        });

        return $containers;
    };

    const generateExtendedHideFunction = function (hideFunction, defaultDuration = 0) {
        var original = hideFunction;
        return function (duration, easing, complete) {
            if ($(this).data("use-original-hide-show")) {
                // if an element is marked with the html5 data attribute "use-original-hide-show",
                // then don't hide it with the "hidden" attribute and just use the original way to hide it.
                return original.apply(this, arguments);
            }

            const callback = function () {
                if (complete) {
                    complete.apply(this);
                } else if (easing && typeof (easing) === "function") {
                    easing.apply(this);
                } else if ($.isPlainObject(duration)) {
                    const options = duration;
                    if (options.tempComplete) {
                        options.tempComplete.apply(this);
                    }
                }

                $(this).prop("hidden", true);
                $(this).data("css-display", $(this).css("display"));
                $(this).css("display", "");
            };

            if (!duration) {
                return original.call(this, defaultDuration, callback);
            }

            if (!easing) {
                if ($.isPlainObject(duration)) {
                    const options = duration;
                    options.tempComplete = options.complete;
                    options.complete = callback;

                    return original.call(this, options);
                }

                return original.call(this, duration, callback);
            }

            if (!complete) {
                return original.call(this, duration, callback);
            }

            return original.call(this, duration, easing, callback);
        };
    };

    // use "hidden" attribute to hide, instead of the style's display: none;
    $.fn.hide = generateExtendedHideFunction($.fn.hide);
    $.fn.fadeOut = generateExtendedHideFunction($.fn.fadeOut, 400);
    $.fn.slideUp = generateExtendedHideFunction($.fn.slideUp, 400);

    const generateExtendedShowFunction = function (showFunction, defaultDuration = 0) {
        var original = showFunction;
        return function (duration, easing, complete) {
            if ($(this).data("use-original-hide-show")) {
                // if an element is marked with the html5 data attribute "use-original-hide-show",
                // then use the original way of showing the element.
                return original.apply(this, arguments);
            }

            const cssDisplay = $(this).data("css-display");
            if (cssDisplay) {
                this.css("display", cssDisplay);
            }
            $(this).prop("hidden", false);

            if (!duration) {
                return original.call(this, defaultDuration, complete);
            }

            if (!easing) {
                if ($.isPlainObject(duration)) {
                    const options = duration;

                    return original.call(this, options);
                }

                return original.call(this, duration, complete);
            }

            return original.apply(this, arguments);
        };
    };

    $.fn.show = generateExtendedShowFunction($.fn.show);
    $.fn.fadeIn = generateExtendedShowFunction($.fn.fadeIn, 400);
    $.fn.slideDown = generateExtendedShowFunction($.fn.slideDown, 400);


    $.fn.refreshMetronicSwitch = function () {
        const $elements = this;

        $elements.each(function () {
            const $element = $(this);

            const $switch = $element.closest(".switch");
            if ($switch.length > 0) {
                if ($element.is(":checked")) {
                    $switch.addClass(`switch-${$switch.data("color-set")}`);
                } else {
                    $switch.removeClass(`switch-${$switch.data("color-set")}`);
                }
            }
        });

        return $elements;
    };

    /**
     * Get the offset of an element relative to an ancestor element.
     * The ancestor param must be a positioned DOM element.
     * An element is said to be positioned if it has a CSS position attribute of relative, absolute, or fixed.
     * @param {Element | jQuery | string} ancestor
     */
    $.fn.getAncestorOffset = function (ancestor) {
        const $ancestor = !ancestor ? $("html") : $(ancestor);

        const offset = {
            top: 0,
            left: 0
        };
        let $element = this;
        let shouldStop = false;

        if ($element.get(0) !== $ancestor.get(0)
            && $element.get(0) !== $("body").get(0)
            && $element.get(0) !== $("html").get(0)) {
            do {
                const position = $element.position();
                offset.top += position.top;
                offset.top += parseFloat($element.css("margin-top"));
                offset.top += parseFloat($element.css("border-top-width"));

                offset.left += position.left;
                offset.left += parseFloat($element.css("margin-left"));
                offset.left += parseFloat($element.css("border-left-width"));

                $element = $element.offsetParent();
                if ($element.get(0) === $ancestor.get(0)
                    || $element.get(0) === $("body").get(0)
                    || $element.get(0) === $("html").get(0)) {
                    shouldStop = true;
                }
            } while (!shouldStop);
        }

        return offset;
    };

    $.fn.getSelectizeData = function () {
        const $this = this;

        if (!$this.is("select")) {
            return null;
        }

        const selectize = $this.get(0).selectize;

        return selectize.getItem(selectize.getValue()).data();
    };

    $.fn.setDropDownValue = function (value) {
        const $this = this;

        if (!$this.is("select")) {
            return;
        }

        $this.val(value);
        $this.attr("data-original-value", value);
    };

    /*
    This method sets the value of a dynamic soon-to-be-selectize-initialised. The dropdown in question is still a <select> at the time of calling and is dynamic where
    the <option> elements might not be completely loaded yet. An AJAX request is called later to have the dropdown populated.
    Setting a value of a <select> whose <option> doesn't exist, will not set the value successfully.
    This method will create a temporary <option> that will hold the value to be set and appended to the <select> so that it could be set successfully.
    */
    $.fn.setDynamicDropDownValue = function (value, text, data) {
        const $this = this;

        if (!$this.is("select")) {
            return;
        }

        const $options = $("option", $this);
        const $option = $options.filter(`[value="${value}"]`);
        if ($option.length === 0) {
            const $tempOptionToBeInserted = $(`<option value="${value}">${text}</option>`);

            if (data) {
                $tempOptionToBeInserted.data("data", data);
            }

            $this.append($tempOptionToBeInserted);
        }

        $this.val(value);
        $this.attr("data-original-value", value);
    };

    $.fn.isInView = function (container) {
        const $this = this;

        if ($this.is(":hidden")) {
            return false;
        }

        container = container || document.body;

        if (container == document.body) {
            const elementHeight = $this.outerHeight();
            const elementTop = $this.offset().top;
            const elementBottom = elementTop + elementHeight;

            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();

            if (window.KTUtil.isDesktopDevice()) {
                // #region top

                if (window.KTLayoutHeader && window.KTLayoutHeader.isFixed()) {
                    const $header = $("body.header-fixed .header");
                    const $headerChildren = $header.children(":visible");
                    if ($headerChildren.length > 0) {
                        $headerChildren.each(function () {
                            viewportTop += $(this).outerHeight(true);
                        });
                    } else {
                        viewportTop = $header.outerHeight();
                    }
                }

                if (window.KTLayoutSubheader && window.KTLayoutSubheader.isFixed()) {
                    const $subheader = $("body.subheader-fixed .subheader, body.header-fixed .header-bottom");
                    viewportTop += $subheader.outerHeight();
                }

                // #endregion

                // #region bottom

                const $footer = $("body.footer-fixed .footer");
                if ($footer.length) {
                    viewportBottom -= window.KTLayoutFooter ? window.KTLayoutFooter.getHeight() : 0;
                    //containerRect.height -= window.KTLayoutFooter ? window.KTLayoutFooter.getHeight() : 0;
                }

                // #endregion
            } else if (window.KTUtil.isMobileDevice()) {
                if (window.KTLayoutHeader && window.KTLayoutHeader.isFixedForMobile()) {
                    // #region top

                    viewportTop = window.KTLayoutHeader.getHeightForMobile();

                    if ($("body").hasClass("topbar-mobile-on")) {
                        viewportTop += window.KTUtil.actualHeight($(".topbar-mobile-on .topbar").get(0), false);;
                    }

                    // #endregion

                    // #region bottom

                    const $footer = $("body.footer-mobile-fixed .footer-mobile");
                    if ($footer.length) {
                        viewportBottom -= window.KTUtil.actualHeight($footer.get(0), false);
                        //containerRect.height -= window.KTLayoutFooter ? window.KTLayoutFooter.getHeight() : 0;
                    }

                    // #endregion
                }
            }

            return elementBottom - elementHeight >= viewportTop && elementTop/* + elementHeight*/ <= viewportBottom;
        } else {
            const { top, bottom, height } = $this.get(0).getBoundingClientRect();

            const containerRect = $.extend({}, container.getBoundingClientRect());

            return top <= containerRect.top
                ? containerRect.top - top <= 0 /*height*/
                : bottom - containerRect.bottom <= 0 /*height*/;
        }
    };

    $.fn.isScrolledToBottom = function (offset) {
        const $this = this;

        return app.utils.theme.isContentScrolledToBottom($this.get(0), offset);
    };

    $.fn.scrollToTop = function () {
        const $this = this;

        app.utils.theme.scrollToTop($this);
    };

    $.fn.scrollToBottom = function () {
        const $this = this;

        $this.each(function () {
            app.utils.theme.scrollToBottom(this);
        });
    };

    $.fn.resetValidatorElement = function () {
        if (!this.length) {
            return null;
        }

        const $this = this;
        const $form = $this.closest("form");

        const validator = $form.data("validator");
        if (validator) {
            // check if validation of the form has been triggered
            if (!_.isEmpty(validator.submitted)) {
                // validation of the form has been triggered before
                return $this.valid();
            }
        }

        return null;
    }
})(jQuery);

// #region DataTable
(function ($) {
    if (!$) {
        return;
    }

    $.fn.DataTable = (function () {
        const original = $.fn.DataTable;

        return function () {
            this.attr("tabindex", "0");
            const result = original.apply(this, arguments);

            return result;
        };
    })();
})(jQuery);
// #endregion

// #region Tempus Dominus Date Time Picker
(function ($) {
    if (!$) {
        return;
    }

    $.fn.tempusDominus = (function () {
        const original = $.fn.tempusDominus;

        return function () {
            $(this).each(function () {
                const $this = $(this);
                if ($this.hasClass("date-picker")) {
                    $('input[type="text"]', $this).attr("data-rule-date", "true");
                } else if ($this.hasClass("time-picker")) {
                    $('input[type="text"]', $this).attr("data-rule-time", "true");
                } else if ($this.hasClass("datetime-picker")) {
                    $('input[type="text"]', $this).attr("data-rule-datetime", "true");
                }
            });

            const result = original.apply(this, arguments);

            return result;
        };
    })();
})(jQuery);
// #endregion

// #region Floating Scroll
(function ($) {
    if (!$) {
        return;
    }

    $.fn.floatingScroll = (function () {
        const original = $.fn.floatingScroll;

        return function (method = "init") {
            const result = original.apply(this, arguments);

            // floating-scroll doesn't work very well inside Bootstrap's Modal. The floating-scroll doesn't hide even after scrolling past the bottom
            // of the scrolling body. Therefore manually hide it after the bottom of the scrolling body comes into view.
            if (method === "init") {
                this.each(function () {
                    const $scrollableBody = $(this);
                    const $modal = $scrollableBody.closest(".modal");
                    if ($modal.length > 0) {
                        let $scrollablePane;
                        let isScrollableModal;
                        if ($scrollableBody.closest(".modal-dialog-scrollable").length > 0) {
                            isScrollableModal = true;

                            const $dataTableWrapper = $scrollableBody.closest(".dataTables_wrapper");
                            if ($dataTableWrapper.length > 0) {
                                const api = $(".dataTables_scrollBody table", $dataTableWrapper).DataTable();
                                const scrollableContainer = api.fixedHeader.scrollableContainer();
                                $scrollablePane = scrollableContainer ? (scrollableContainer instanceof $ ? scrollableContainer : $(scrollableContainer)) : $scrollableBody.closest(".modal-body");
                            } else {
                                $scrollablePane = $scrollableBody.closest(".modal-body");
                            }
                        } else {
                            isScrollableModal = false;
                            $scrollablePane = $modal;
                        }

                        $scrollablePane.on("scroll", app.throttle(50, function () {
                            let scrollablePaneOffsetFromBottom = 0;
                            if (isScrollableModal) {
                                const scrollablePaneOffsetBottom = $scrollablePane.offset().top - $(document).scrollTop() + $scrollablePane.outerHeight();
                                scrollablePaneOffsetFromBottom = $modal.outerHeight() - scrollablePaneOffsetBottom;
                            }

                            $(".fl-scrolls", $scrollableBody).each(function () {
                                const $floatingScroll = $(this);

                                //console.log(`$scrollableBody.height(): ${$scrollableBody.height()}, $scrollablePane.outerHeight(): ${$scrollablePane.outerHeight()}, $scrollableBody.offset().top: ${$scrollableBody.offset().top}, $(document).scrollTop(): ${$(document).scrollTop()}, scrollablePaneOffsetFromBottom: ${scrollablePaneOffsetFromBottom}, scrollablePaneOffsetFromBottom: ${scrollablePaneOffsetFromBottom}, $floatingScroll.height(): ${$floatingScroll.height()}, computation: ${$scrollableBody.height() - $scrollablePane.outerHeight() + ($scrollableBody.offset().top - $(document).scrollTop()) - scrollablePaneOffsetFromBottom - $floatingScroll.height()}`);

                                if ($scrollableBody.height() - $scrollablePane.outerHeight() + ($scrollableBody.offset().top - $(document).scrollTop()) - scrollablePaneOffsetFromBottom + $floatingScroll.height() < 0) {
                                    $floatingScroll.addClass("fl-scrolls-hidden");
                                } else {
                                    $floatingScroll.removeClass("fl-scrolls-hidden");
                                }
                            });

                        }));
                    }
                });
            } else if (method === "update") {
                this.each(function () {
                    const $scrollableBody = $(this);

                    const $dataTableWrapper = $scrollableBody.closest(".dataTables_wrapper");
                    if ($dataTableWrapper.length === 0 || $("tfoot", $dataTableWrapper).length === 0) {
                        // only applicable to scrollable content not inside a datatable because that has been catered for in datatables.defaults.js
                        // or a datatable that doesn't have a footer.
                        const $modal = $scrollableBody.closest(".modal");
                        if ($modal.length > 0) {
                            if ($scrollableBody.closest(".modal-dialog-scrollable").length > 0) {
                                let $scrollablePane;
                                let scrollablePaneOffsetTop;

                                if ($dataTableWrapper.length > 0) {
                                    const api = $(".dataTables_scrollBody table", $dataTableWrapper).DataTable();
                                    const scrollableContainer = api.fixedHeader.scrollableContainer();
                                    $scrollablePane = scrollableContainer ? (scrollableContainer instanceof $ ? scrollableContainer : $(scrollableContainer)) : $scrollableBody.closest(".modal-body");

                                    scrollablePaneOffsetTop = $scrollablePane.offset().top - $(document).scrollTop();
                                } else {
                                    $scrollablePane = $scrollableBody.closest(".modal-body");
                                    scrollablePaneOffsetTop = $scrollablePane.offset().top;
                                }

                                const scrollablePaneOffsetBottom = scrollablePaneOffsetTop + $scrollablePane.outerHeight();
                                $(".fl-scrolls", $scrollablePane).css("bottom", $modal.outerHeight() - scrollablePaneOffsetBottom);
                            }
                        }
                    }
                });
            }

            return result;
        };
    })();
})(jQuery);
// #endregion

// #region Selectize
(function ($) {
    if (!$) {
        return;
    }

    $(document).on("change", ".selectized", function () {
        if (this.selectize.settings.mode === "multi") {
            this.selectize.focus();
        }

        const validator = $(this).closest("form").data("validator");
        if (validator) {
            validator.element(`[name="${$(this).attr("name")}"]`);
        }
    });

    // #region Blur previous selectize
    // multiple selectize dropdowns can be opened at the same time,
    // the codes below is to disable such behaviour and close the previous dropdown when the next one is opened.
    let selectizeControl;
    $(document).on("focusin", ".selectize-control", function (e) {
        if (selectizeControl && selectizeControl.isConnected && selectizeControl !== this) {
            // blur the previous focused selectize
            $(selectizeControl).prev().get(0).selectize.blur();
        }

        selectizeControl = this;
    });
    // #endregion

    $(document).on("mouseout", ".selectize-control", function () {
        try {
            $('[data-toggle="tooltip"]', this).tooltip("hide");
        } catch (e) {
        }
    });

    window.Selectize.define("clear_selection", function (options) {
        const self = this;
        // options: plugin-specific options
        // this: Selectize instance
        self.require("plugin_container");

        self.setup = (function () {
            const original = self.setup;
            return function () {
                original.apply(this, arguments);

                const selectize = this;

                // persistedValue holds the value of the selectize and is not removed on clear() unless the "clear button" is explicitly clicked.
                selectize.persistedValue = selectize.getValue();

                const $i = $("<i></i>")
                    .attr("title", app.localize("Clear"))
                    .attr("data-toggle", "tooltip")
                    .addClass("selectize-clear-selection")
                    .addClass("fad fa-xmark");

                const $pluginContainer = $(".plugin-container", selectize.$wrapper);

                const $createControl = $(".selectize-create", $pluginContainer);
                if ($createControl.length > 0) {
                    $createControl.before($i);
                } else {
                    const $refreshControl = $(".selectize-refresh", $pluginContainer);
                    if ($refreshControl.length > 0) {
                        $refreshControl.before($i);
                    } else {
                        const $busyControl = $(".selectize-busy", $pluginContainer);
                        if ($busyControl.length > 0) {
                            $busyControl.before($i);
                        } else {
                            const $infoControl = $(".selectize-info", $pluginContainer);
                            if ($infoControl.length > 0) {
                                $infoControl.before($i);
                            } else {
                                $pluginContainer.append($i);
                            }
                        }
                    }
                }

                //selectize.$clearSelectionControl = $i;

                selectize.on("change", function (value) {
                    if ((!this.settings_user?.allowEmptyOption ?? false) && !value) {
                        return;
                    }

                    this.persistedValue = value;
                });
                selectize.on("clear", function () {
                    const $form = this.$input.closest("form");
                    const validator = $form.data("validator");
                    if (validator && this.$input.is(`[name]`)) {
                        validator.element(`[name="${this.$input.attr("name")}"]`);
                    }
                });

                $i.hover(function () {
                    $i
                        .removeClass("fad")
                        .addClass("fas");
                }, function () {
                    $i
                        .removeClass("fas")
                        .addClass("fad");
                });

                $i.click(function (e) {
                    if (options && options.onClear) {
                        options.onClear.apply(selectize, arguments);
                    }
                    selectize.trigger("clearing", ...arguments);

                    if (!e.isDefaultPrevented()) {
                        selectize.persistedValue = null;
                        selectize.clear();

                        if (options && options.onCleared) {
                            options.onCleared.apply(selectize, arguments);
                        }
                        selectize.trigger("cleared", ...arguments);
                    }
                });
            };
        })();
    });

    window.Selectize.define("create", function (options) {
        const self = this;
        // options: plugin-specific options
        // this: Selectize instance
        self.require("plugin_container");

        self.setup = (function () {
            const original = self.setup;
            return function () {
                original.apply(this, arguments);

                const selectize = this;

                const $i = $("<i></i>")
                    .attr("title", app.localize("Create"))
                    .attr("data-toggle", "tooltip")
                    .addClass("selectize-create")
                    .addClass("fad fa-plus");

                const $pluginContainer = $(".plugin-container", selectize.$wrapper);

                const $refreshControl = $(".selectize-refresh", $pluginContainer);
                if ($refreshControl.length > 0) {
                    $refreshControl.before($i);
                } else {
                    const $busyControl = $(".selectize-busy", $pluginContainer);
                    if ($busyControl.length > 0) {
                        $busyControl.before($i);
                    } else {
                        const $infoControl = $(".selectize-info", $pluginContainer);
                        if ($infoControl.length > 0) {
                            $infoControl.before($i);
                        } else {
                            $pluginContainer.append($i);
                        }
                    }
                }

                //selectize.$createControl = $i;
                selectize.create = function () {
                    if (_.isObject(options)) {
                        if (options.action) {
                            if (_.isFunction(options.action)) {
                                const result = options.action.call(selectize);
                                if (typeof (result) === "string") {
                                    window.open(result, "_blank").focus();
                                }
                            } else if (typeof (options.action) === "string") {
                                window.open(options.action, "_blank").focus();
                            }
                        }
                    } else if (_.isFunction(options)) {
                        const result = options.call(selectize);
                        if (typeof (result) === "string") {
                            window.open(result, "_blank").focus();
                        }
                    } else if (typeof (options) === "string") {
                        window.open(options, "_blank").focus();
                    } else {
                        alert("No action provided.");
                    }
                };

                $i.hover(function () {
                    $i
                        .removeClass("fad")
                        .addClass("fas");
                }, function () {
                    $i
                        .removeClass("fas")
                        .addClass("fad");
                });

                $i.click(selectize.create);
            };
        })();
    });

    window.Selectize.define("refresh", function (options) {
        const self = this;
        // options: plugin-specific options
        // this: Selectize instance
        self.require("plugin_container");

        function refreshOptions(rawData) {
            const selectize = this;

            let data = rawData;
            if (options.dataMassage) {
                data = options.dataMassage.call(selectize, rawData);
            } else {
                if (data !== undefined && data !== null) {
                    data = _.map(data,
                        function (item) {
                            return { value: item.key, text: item.value };
                        });
                }
            }

            const selectedValue = selectize.getValue();
            selectize.clear(true);
            selectize.clearOptions();
            selectize.load(function (callback) {
                if (data !== undefined && data !== null) {
                    callback(data);
                    selectize.setValue(selectedValue, true);
                }
            });

            const $form = selectize.$input.closest("form");
            const validator = $form.data("validator");
            if (validator && selectize.$input.is(`[name]`)) {
                validator.element(`[name="${selectize.$input.attr("name")}"]`);
            }

            revertControlToDefaultState.call(selectize);
        }

        let $refreshControl;
        function revertControlToDefaultState() {
            const selectize = this;

            selectize.isRefreshing = false;

            $refreshControl
                .removeClass("fad fa-spinner fa-spin")
                .removeClass("fas fa-triangle-exclamation")
                .removeClass("text-danger")
                .addClass("fas fa-arrows-rotate")
                .attr("data-original-title", app.localize("Refresh"));

            if ($refreshControl.attr("aria-describedby")) {
                // when the mouse cursor is over an element with tooltip shown, the element will have the attribute "aria-describedby".
                try {
                    $refreshControl.tooltip("show");
                } catch (e) {
                    $refreshControl.tooltip("update");
                }
            } else {
                $refreshControl.tooltip("hide");
            }

            selectize.trigger("refreshed", ...arguments);
        }

        self.setup = (function () {
            const original = self.setup;
            return function () {
                original.apply(this, arguments);

                const selectize = this;

                const $i = $("<i></i>")
                    .attr("title", app.localize("Refresh"))
                    .attr("data-toggle", "tooltip")
                    .addClass("selectize-refresh")
                    .addClass("fas fa-arrows-rotate");

                const $pluginContainer = $(".plugin-container", selectize.$wrapper);

                const $busyControl = $(".selectize-busy", $pluginContainer);
                if ($busyControl.length > 0) {
                    $busyControl.before($i);
                } else {
                    const $infoControl = $(".selectize-info", $pluginContainer);
                    if ($infoControl.length > 0) {
                        $infoControl.before($i);
                    } else {
                        $pluginContainer.append($i);
                    }
                }

                $refreshControl = $i;
                selectize.refresh = function (callback) {
                    if ($i.hasClass("fa-arrows-rotate")) {
                        if (options.source) {
                            selectize.isRefreshing = true;

                            $i
                                .removeClass("fas fa-arrows-rotate")
                                .addClass("fad fa-spinner fa-spin")
                                .attr("data-original-title", app.localize("Refreshing"));

                            if ($i.attr("aria-describedby")) {
                                try {
                                    $i.tooltip("show");
                                } catch (e) {
                                    $i.tooltip("update");
                                }
                            } else {
                                $i.tooltip("hide");
                            }

                            const $deferred = options.source.call(selectize, { sender: $i.get(0) });
                            if ($deferred.always) { // if it's a jQuery deferred object
                                const h = ++hash;
                                $deferred
                                    .done(function (data) {
                                        if (h === hash) {
                                            refreshOptions.call(selectize, data);

                                            if (callback) {
                                                callback.call(selectize);
                                            }
                                        }
                                    })
                                    .fail(function () {
                                        if (h === hash) {
                                            $i
                                                .removeClass("fad fa-spinner fa-spin")
                                                .addClass("fas fa-triangle-exclamation")
                                                .addClass("text-danger")
                                                .attr("data-original-title", app.localize("Refreshing.Error"));

                                            if ($i.attr("aria-describedby")) {
                                                try {
                                                    $i.tooltip("show");
                                                } catch (e) {
                                                    $i.tooltip("update");
                                                }
                                            } else {
                                                $i.tooltip("hide");
                                            }
                                        }
                                    });
                            } else {
                                if ($deferred === false) {
                                    revertControlToDefaultState.call(selectize);
                                } else {
                                    refreshOptions.call(selectize, $deferred);

                                    if (callback) {
                                        callback.call(selectize);
                                    }
                                }
                            }
                        } else {
                            alert("Unable to refresh. 'source' is not defined.");
                        }
                    } else {
                        // click once again to cancel

                        hash++; // increment hash so that the previous ajax call will not be processed regardless of success or failed.

                        revertControlToDefaultState.call(selectize);
                    }
                };

                let hash = 0;
                $i.click(function () {
                    selectize.refresh(function () {
                        const selectize = this;

                        selectize.open();
                        selectize.isOpened = true;
                    });
                });
            };
        })();
    });

    window.Selectize.define("busy", function (options) {
        const self = this;
        // options: plugin-specific options
        // this: Selectize instance

        self.setup = (function () {
            const original = self.setup;
            return function () {
                original.apply(this, arguments);

                const selectize = this;

                const $i = $("<i></i>")
                    .addClass("selectize-busy")
                    .addClass("fad fa-spinner fa-spin");

                const $pluginContainer = $(".plugin-container", selectize.$wrapper);

                const $infoControl = $(".selectize-info", $pluginContainer);
                if ($infoControl.length > 0) {
                    $infoControl.before($i);
                } else {
                    $pluginContainer.append($i);
                }

                selectize.setBusy = function () {
                    selectize.disable();
                    selectize.$wrapper.addClass("loading");
                };

                selectize.clearBusy = function () {
                    selectize.$wrapper.removeClass("loading");
                    selectize.enable();
                };
            };
        })();
    });

    window.Selectize.define("info", function (options) {
        const self = this;
        // options: plugin-specific options
        // options.showInfo(data) : a function that returns a boolean to indicate if the "info" icon should be displayed.
        // options.tooltipText(data) : a function that returns a string to display the text when mouseover. Only applicable when showInfo(data) returns true.
        // options.triggerInfo(e, data) : a function that will be called when the "info" icon is clicked.
        // this: Selectize instance

        self.require("plugin_container");

        /**
         * Appends an element as a child (with raw HTML).
         *
         * @param {string} containerHtml
         * @param {string} elementHtml
         * @return {string}
         */
        const append = function (containerHtml, elementHtml) {
            const pos = containerHtml.search(/(<\/[^>]+>\s*)$/);
            return containerHtml.substring(0, pos) + elementHtml + containerHtml.substring(pos);
        };

        self.setup = (function () {
            const original = self.setup;
            return function () {
                original.apply(this, arguments);

                const selectize = this;

                // #region item
                if (selectize.settings.mode === "single") {
                    const $i = $("<i></i>")
                        .attr("data-toggle", "tooltip")
                        .addClass("selectize-info")
                        .addClass("info");

                    let data;
                    const value = selectize.getValue();
                    if (value) {
                        const $item = selectize.getItem(value);
                        data = $item.data();
                        data.text = $item.text().trim();
                    }
                    const tooltipText = options.tooltipText && value ? options.tooltipText.call(selectize, data) : app.localize("Info");

                    $i.attr("title", tooltipText);
                    if (value && (options.showInfo && !options.showInfo.call(selectize, data))) {
                        $i.hide();
                    }

                    $(".plugin-container", selectize.$wrapper).append($i);
                    //selectize.$infoControl = $i;

                    selectize.info = function (e) {
                        if (options.triggerInfo) {
                            const v = selectize.getValue();
                            if (v) {
                                const $item = selectize.getItem(v);
                                const data = $item.data();
                                data.text = $item.text().trim();

                                e.sender = this;
                                options.triggerInfo.call(selectize, e, data);
                            }
                        }
                    };

                    $i.click(selectize.info);

                    selectize.on("change", function (value) {
                        if (value) {
                            const $item = selectize.getItem(value);
                            const data = $item.data();
                            data.text = $item.text().trim();

                            if (!options.showInfo || options.showInfo.call(selectize, data)) {
                                if (options.tooltipText) {
                                    const tooltipText = options.tooltipText.call(selectize, data);

                                    const attr = $i.attr("data-original-title");
                                    if (attr === undefined || attr === false) {
                                        $i.attr("title", tooltipText);
                                    } else {
                                        $i.attr("data-original-title", tooltipText);
                                    }
                                }

                                // if showInfo() function is not defined, or if showInfo() returns true, display the "info" icon.
                                $i.show();
                            } else {
                                $i.hide();
                            }
                        } else {
                            $i.hide();
                        }
                    });

                    selectize.on("clear", function () {
                        $i.hide();
                    });
                } else if (selectize.settings.mode === "multi") {
                    selectize.$control.on("click", ".item .block", function (e) {
                        if (options.triggerInfo) {
                            const $item = $(this).closest(".item");
                            e.sender = $item.get(0);

                            const data = selectize.getItem($item.data("value")).data();
                            data.text = $item.text().trim();
                            options.triggerInfo.call(selectize, e, data);
                        }
                    });

                    selectize.on("change", function (value) {
                        if (value) {
                            let values = value;
                            if (!_.isArray(value)) {
                                values = [value];
                            }

                            _.each(values, function (value) {
                                const $item = selectize.getItem(value);
                                const $itemBlock = $(".block", $item);

                                const attr = $itemBlock.attr("data-toggle");
                                if (attr === undefined || attr === false) {
                                    const data = $item.data();
                                    data.text = $itemBlock.text().trim();

                                    if (!options.showInfo || options.showInfo.call(selectize, data)) {
                                        if (options.tooltipText) {
                                            const tooltipText = options.tooltipText.call(selectize, data);

                                            $itemBlock
                                                .attr("data-toggle", "tooltip")
                                                .attr("title", tooltipText);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
                // #endregion

                // #region option
                const renderOption = selectize.settings.render.option;
                selectize.settings.render.option = function (data, escape) {
                    const option = renderOption.apply(selectize, arguments);

                    const conciseData = $.extend({
                        value: data.value,
                        text: data.text
                    }, data.data);
                    if (!options.showInfo || options.showInfo.call(selectize, conciseData)) {
                        // if showInfo() function is not defined, or if showInfo() returns true, display the "info" icon.
                        const tooltipText = options.tooltipText ? options.tooltipText.call(selectize, conciseData) : app.localize("Info");

                        const infoHtml = `<i class="fas fa-circle-info info" title="${tooltipText}" data-toggle="tooltip" data-html="true"></i>`;

                        return append(option, infoHtml);
                    }

                    return option;
                };

                selectize.$dropdown_content.on("mouseup", ".option .info", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
                selectize.$dropdown_content.on("click", ".option .info", function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (options.triggerInfo) {
                        const $option = $(this).closest(".option");
                        e.sender = this;
                        options.triggerInfo.call(selectize, e, selectize.getOption($option.data("value")).data());
                    }
                });
                // #endregion
            };
        })();
    });

    window.Selectize.define("plugin_container", function (options) {
        const self = this;
        // options: plugin-specific options
        // this: Selectize instance

        self.setup = (function () {
            const original = self.setup;
            return function () {
                original.apply(this, arguments);

                const selectize = this;
                selectize.$control.after('<div class="plugin-container"></div>');
            };
        })();
    });

    // This overrides the selectize.js original auto_position plugin.
    window.Selectize.define("auto_position", function () {
        var self = this;

        const POSITION = {
            top: 'top',
            bottom: 'bottom',
        };

        self.positionDropdown = (function () {
            return function () {
                if (!self.isOpen) {
                    // only applicable when the dropdown is open.
                    return;
                }

                const $dropdown = this.$dropdown;
                const $control = this.$control;
                const $wrapper = this.$wrapper;
                const settings = this.settings;

                // $.fn.hide has been customised to add a "hidden" attribute to the element to be hidden.
                // This prevents selectize from obtaining "scrollHeight" since it's not visible.
                // Here we restore the original state so that the measurements can be obtained.
                $dropdown.addClass("dropdown-active");
                $dropdown.removeAttr("hidden");

                // in a multi dropdown box, at this point after an option is selected, the option is already removed from the dropdown list and the latest list of options is already reflected.
                // however, if an option is unselected, the option is not returned to the dropdown list yet at this point. Therefore we put the codes below into a setTimeout to wait until the option
                // is returned to the dropdown list first so that the latest dimension can be taken of the dropdown list.
                setTimeout(function () {
                    // if the dropdown list has the class "dropdown-active" (which was added above), it won't remove the "dropdown-activating" class.
                    // therefore we need to explicitly remove it.
                    $dropdown.removeClass("dropdown-activating");

                    const offset = settings.dropdownParent === 'body' ? $control.offset() : $control.position();
                    offset.top += $control.outerHeight(true);

                    const dropdownHeight = $dropdown.prop('scrollHeight') + 5; // 5 - padding value;
                    const controlPosTop = $control.get(0).getBoundingClientRect().top;
                    const wrapperHeight = $wrapper.height();
                    const controlPosBottom = self.$control.get(0).getBoundingClientRect().bottom;
                    const position = controlPosTop + dropdownHeight + wrapperHeight > window.innerHeight && controlPosBottom - dropdownHeight - wrapperHeight >= 0 ? POSITION.top : POSITION.bottom;
                    //const position = controlPosTop + dropdownHeight + wrapperHeight > window.innerHeight ? POSITION.top : POSITION.bottom;
                    const styles = {
                        width: $control.outerWidth(),
                        left: offset.left
                    };
                    
                    if (position === POSITION.top) {
                        const styleToAdd = { bottom: offset.top + 2, top: 'unset' };

                        if (settings.dropdownParent === 'body') {
                            styleToAdd.top = offset.top - $dropdown.outerHeight(true) - $control.outerHeight(true) - 2;
                            styleToAdd.bottom = 'unset';
                        }
                        Object.assign(styles, styleToAdd);
                        $dropdown.addClass('selectize-position-top');
                        $control.addClass('selectize-position-top');
                    } else {
                        Object.assign(styles, { top: offset.top, bottom: 'unset' });
                        $dropdown.removeClass('selectize-position-top');
                        $control.removeClass('selectize-position-top');
                    }
                    
                    $dropdown.css(styles);
                });
            };
        }());
    });

    // selectize.js plugins
    window.Selectize.define("toggle_open_close", function (options) {
        const self = this;
        // options: plugin-specific options
        // this: Selectize instance

        if (!window.Selectize.plugins["toggle_open_close"].hasInitialized) {
            $(document).on("click", ".selectize-control .selectize-input", function (e) {
                const selectize = $(e.target).closest(".selectize-control").prev().get(0).selectize;
                if (!selectize.isOpened) {
                    selectize.open();
                    selectize.isOpened = true;
                } else {
                    selectize.close();
                    selectize.isOpened = false;
                }
            });

            //$(document).on("focusout", ".selectize-control", function (e) {
            //    const selectize = $(this).prev().get(0).selectize;
            //    selectize.isOpened = false;
            //});
            //$(document).on("change", ".selectized", function (e) {
            //    const selectize = e.target.selectize;
            //    if (selectize.isFull()) {
            //        selectize.isOpened = false;
            //    }
            //});

            window.Selectize.plugins["toggle_open_close"].hasInitialized = true;
        }

        self.setup = (function () {
            const original = self.setup;
            return function () {
                original.apply(this, arguments);

                const selectize = this;

                selectize.on("blur", function () {
                    this.isOpened = false;
                });
                selectize.on("change", function () {
                    const s = this;
                    setTimeout(function () {
                        if (s.isFull()) {
                            s.isOpened = false;
                        }
                    });
                });
                selectize.$dropdown_content.on("click", ".option", function () {
                    if (selectize.isFull()) {
                        selectize.isOpened = false;
                    }
                });


                selectize.$control_input.on("keydown", function (e) {
                    const selectize = $(e.target).closest(".selectize-control").prev().get(0).selectize;

                    switch (e.key) {
                        case app.consts.keyboardKey.escape:
                            selectize.isOpened = false;
                            break;

                        case app.consts.keyboardKey.enter:
                            if (selectize.isOpened) {
                                e.stopPropagation();
                                selectize.isOpened = false;
                            }
                            break;

                        default:
                            setTimeout(function () {
                                if (selectize.$control.hasClass("dropdown-active")) {
                                    selectize.isOpened = true;
                                } else {
                                    selectize.isOpened = false;
                                }
                            });
                            break;
                    }
                });
            };
        })();
    });

    // #region This utility method is copied over from selectize.js source in its entirety. Since this is declared as a variable and therefore not reusable here, we have this copied over.

    var debounce_events = function (self, types, fn) {
        var type;
        var trigger = self.trigger;
        var event_args = {};

        self.trigger = function () {
            var type = arguments[0];
            if (types.indexOf(type) !== -1) {
                event_args[type] = arguments;
            } else {
                return trigger.apply(self, arguments);
            }
        };

        fn.apply(self, []);
        self.trigger = trigger;

        for (type in event_args) {
            if (event_args.hasOwnProperty(type)) {
                trigger.apply(self, event_args[type]);
            }
        }
    };

    var hash_key = function (value) {
        if (typeof value === 'undefined' || value === null) return null;
        if (typeof value === 'boolean') return value ? '1' : '0';
        return value + '';
    };

    // #endregion

    // The built-in function of selectize to check validation state is not suitable for our custom jQuery Validate
    // Therefore provide our own implementation.
    window.Selectize.prototype.refreshValidityState = function () {
        if (!this.isRequired) return false;

        return !this.items.length;
    };

    window.Selectize.prototype.close = function () {
        const self = this;

        const e = $.Event("dropdown_closing");
        if (self.settings && self.settings.onDropdownClosing) {
            self.settings.onDropdownClosing.call(self, e, self.$dropdown);
        }

        self.trigger("dropdown_closing", e, self.$dropdown);

        if (e.isDefaultPrevented() || self.preventClose) {
            return;
        }

        const trigger = self.isOpen;

        if (self.settings.mode === "single" && self.items.length) {
            self.hideInput();

            if (self.isBlurring) {
                self.$control_input[0].blur();
            }
        }

        self.isOpen = false;

        if (trigger) {
            const $dropdownContent = $(".selectize-dropdown-content", self.$dropdown);
            // caters for when the dropdown opening was interrupted before the opening animation completes because the dropdown is closed before it's fully opened',
            // cleanup the opening event here.
            self.$dropdown.removeClass("dropdown-activating");
            $dropdownContent.off("transitionend");

            self.$dropdown.addClass("dropdown-deactivating");
            $dropdownContent.one("transitionend", function () {
                self.$dropdown.hide();
                self.$dropdown.removeClass("dropdown-deactivating");
            });
            self.$dropdown.removeClass("dropdown-active");
        }

        self.setActiveOption(null);
        self.refreshState();
        if (trigger) self.trigger("dropdown_close", self.$dropdown);
    };

    // This overrides the selectize.js original clear() function and prevent this function from raising a "clear" event when `silent` is true.
    window.Selectize.prototype.clear = function (silent) {
        var self = this;

        if (!self.items.length) return;
        self.$control.children(':not(input)').remove();
        self.items = [];
        self.lastQuery = null;
        self.setCaret(0);
        self.setActiveItem(null);
        self.updatePlaceholder();
        self.updateOriginalInput({ silent: silent });
        self.refreshState();
        self.showInput();

        if (!silent) {
            self.trigger('clear');
        }
    };

    // This overrides the selectize.js original clearOptions() function and prevent the control from being cleared.
    window.Selectize.prototype.clearOptions = function (silent) {
        var self = this;

        self.loadedSearches = {};
        self.userOptions = {};
        self.renderCache = {};
        var options = self.options;
        $.each(self.options, function (key, value) {
            if (self.items.indexOf(key) === -1) {
                delete options[key];
            }
        });
        self.options = self.sifter.items = options;
        self.lastQuery = null;
        self.trigger('option_clear');
        //self.clear(silent); // just clearing the options, but not clearing the selected value.
    };

    // This overrides the selectize.js original setValue() function and prevent the "clear" event from being raised when a value is selected.
    window.Selectize.prototype.setValue = function (value, silent) {
        const items = Array.isArray(value) ? value : [value];
        if (items.join('') === this.items.join('')) {
            return;
        }

        var events = silent ? [] : ['change'];

        debounce_events(this, events, function () {
            //this.clear(silent);
            this.clear(true); // clears the control without raising the "clear" event.
            this.addItems(value, silent);
        });
    };

    // This overrides the selectize.js original addItem() function and prevent the "clear" event from being raised when an item is added (aka a value is selected).
    window.Selectize.prototype.addItem = function (value, silent) {
        var events = silent ? [] : ['change'];

        debounce_events(this, events, function () {
            var $item, $option, $options;
            var self = this;
            var inputMode = self.settings.mode;
            var i, active, value_next, wasFull;
            value = hash_key(value);

            if (self.items.indexOf(value) !== -1) {
                if (inputMode === 'single') self.close();
                return;
            }

            if (!self.options.hasOwnProperty(value)) return;
            //if (inputMode === 'single') self.clear(silent);
            if (inputMode === 'single') self.clear(true); // clears the control without raising the "clear" event.
            if (inputMode === 'multi' && self.isFull()) return;

            $item = $(self.render('item', self.options[value]));
            wasFull = self.isFull();
            self.items.splice(self.caretPos, 0, value);
            self.insertAtCaret($item);
            if (!self.isPending || (!wasFull && self.isFull())) {
                self.refreshState();
            }

            if (self.isSetup) {
                $options = self.$dropdown_content.find('[data-selectable]');

                if (!self.isPending) {
                    $option = self.getOption(value);
                    value_next = self.getAdjacentOption($option, 1).attr('data-value');
                    self.refreshOptions(self.isFocused && inputMode !== 'single');
                    if (value_next) {
                        self.setActiveOption(self.getOption(value_next));
                    }
                }

                if (!$options.length || self.isFull()) {
                    self.close();
                } else if (!self.isPending) {
                    self.positionDropdown();
                }

                self.updatePlaceholder();
                self.trigger('item_add', value, $item);

                if (!self.isPending) {
                    self.updateOriginalInput({ silent: silent });
                }
            }
        });
    };

    const originalDefaults = $.fn.selectize.defaults;
    const originalSupport = $.fn.selectize.support;
    $.fn.selectize = (function () {
        const defaultSettings = {
            dropdownParent: "body",
            openOnFocus: false,
            setFirstOptionActive: true,
            render: {
                item: function (item, escape) {
                    return `<div class="item">
                                <div class="block">
                                    <span>${escape(item.text)}</span>
                                </div>
                            </div>`;
                },
                option: function (item, escape) {
                    return `<div class="option">
                                <div class="block">
                                    <span>${escape(item.text)}</span>
                                </div>
                            </div>`;
                }
            }
        };

        const defaultPlugins = [
            { name: "auto_position", options: null },
            { name: "plugin_container", options: null },
            { name: "toggle_open_close", options: null },
            { name: "remove_button", options: { title: app.localize("Remove") } }
        ];

        const original = $.fn.selectize;
        return function (options) {
            options = options || {};
            options = $.extend(true, {}, defaultSettings, options);

            options.plugins = options.plugins || [];
            if (_.isArray(options.plugins)) {
                options.plugins = _.map(options.plugins, function (value) {
                    if (_.isObject(value)) {
                        return value;
                    }

                    if (_.isString(value)) {
                        return {
                            name: value,
                            options: null
                        };
                    }

                    throw "Unexpected value. Object or string is expected.";
                });
            } else if (_.isObject(options.plugins)) {
                options.plugins = _.map(options.plugins, function (value, key) {
                    return {
                        name: key,
                        options: value
                    };
                });
            }

            _.each(defaultPlugins, function (defaultPlugin) {
                if (_.every(options.plugins,
                    function (optionPlugin) {
                        return defaultPlugin.name !== optionPlugin.name;
                    })) {
                    options.plugins.push(defaultPlugin);
                }
            });

            // settings can be defined declaratively, eg: <select class="selectize" data-selectize-setting-allow-empty-option="true"></select> -> which would set allowEmptyOption to `true`.
            // plugins can be defined declaratively, eg: <select class="selectize" data-selectize-plugin-clear-selection="true"></select> -> which would use plugin "clear_selection".
            const settingKey = "data-selectize-setting-";
            const pluginKey = "data-selectize-plugin-";
            this.each(function () {
                let settings = {};
                const plugins = [];

                const $element = $(this);

                $.each(this.attributes, function () {
                    if (this.name === "data-selectize-settings") {
                        try {
                            settings = JSON.parse(this.value);
                        } catch (e) {
                            // could be just a variable name (string) that points to a javascript object/function
                            if (typeof (this.value) === "string") {
                                try {
                                    settings = eval(this.value);
                                } catch (e) {
                                }
                            }
                        }
                    } else if (_.startsWith(this.name, settingKey)) {
                        let settingName = _.replace(this.name, settingKey, "");
                        settingName = _.camelCase(settingName);

                        const jQueryDataName = _.replace(this.name, "data-", "");
                        let settingValue = $element.data(jQueryDataName); // using jQuery .data() so that the value could easily be converted automatically from string to null, boolean, int, etc.

                        try {
                            settingValue = JSON.parse(this.value);
                        } catch (e) {
                            // could be just a variable name (string) that points to a javascript object/function
                            if (typeof (settingValue) === "string") {
                                try {
                                    settingValue = eval(settingValue);
                                } catch (e) {
                                }
                            }
                        }

                        settings[settingName] = settingValue;
                    } else if (_.startsWith(this.name, pluginKey)) {
                        let pluginName = _.replace(this.name, pluginKey, "");
                        pluginName = _.replace(pluginName, "-", "_");

                        const jQueryDataName = _.replace(this.name, "data-", "");
                        let pluginValue = $element.data(jQueryDataName); // using jQuery .data() so that the value could easily be converted automatically from string to null, boolean, int, etc.

                        try {
                            pluginValue = JSON.parse(this.value);
                        } catch (e) {
                            // could be just a variable name (string) that points to a javascript object/function
                            if (typeof (pluginValue) === "string") {
                                try {
                                    pluginValue = eval(pluginValue);
                                } catch (e) {
                                }
                            }
                        }

                        if (!_.isBoolean(pluginValue) || pluginValue === true) {
                            plugins.push({
                                name: pluginName, options: _.isBoolean(pluginValue) ? {} : pluginValue
                            });
                        }
                    }
                });

                const isSelected = $element.is("select") && $element.children('option[selected="selected"]').length;

                settings = $.extend({}, options, settings);
                settings.plugins = settings.plugins.concat(plugins);

                const isHidden = $element.attr("hidden") || $element.css("display") == "none"; // is the element hidden initially?

                original.call($element, settings);
                const selectize = this.selectize;

                if (isHidden) {
                    selectize.$wrapper.hide(); // if hidden initially, hide it after initialised.
                }

                selectize.on("dropdown_open", function () {
                    const self = this;

                    // $.fn.hide has been customised to add a "hidden" attribute to the element to be hidden.
                    // selectize apparently use this jQuery method to hide the dropdown but doesn't use its "show" counterpart to unhide it.
                    // therefore we need to manually unhide the dropdown when it's attempting to show.
                    self.$dropdown.prop("hidden", false);

                    const $dropdownContent = $(".selectize-dropdown-content", self.$dropdown);

                    // caters for when the dropdown closing was interrupted before the closing animation completes because the dropdown is opened again before it's fully closed,
                    // cleanup the closing event here.
                    self.$dropdown.removeClass("dropdown-deactivating");
                    $dropdownContent.off("transitionend");

                    self.$dropdown.addClass("dropdown-activating");
                    $dropdownContent.one("transitionend", function () {
                        self.$dropdown.removeClass("dropdown-activating");

                        let option;
                        const value = self.getValue();
                        if (value && (!_.isArray(value) || !_.isEmpty(value))) {
                            let v = value;
                            if (_.isArray(value)) {
                                v = value[0];
                            }

                            const $option = self.getOption(v);
                            option = $option.get(0);
                        } else {
                            const $option = self.getFirstOption();
                            option = $option.get(0);
                        }

                        if (option) {
                            window.scrollIntoView(option, {
                                scrollMode: "if-needed",
                                block: "nearest",
                                inline: "nearest"
                            });
                        }
                    });

                    setTimeout(function () {
                        self.$dropdown.addClass("dropdown-active");
                    });
                });

                if (settings.allowEmptyOption && $element.is("select")) {
                    if (!isSelected || !selectize.getValue()) {
                        // allowEmptyOption means an <option> tag with an empty value is added to the <select> element.
                        // this <option> element should be automatically selected when no other options are selected.
                        selectize.addItem($element.children("option:first").val());
                    }
                }
            });

            return this;
        };
    })();

    $.fn.selectize.defaults = originalDefaults;
    $.fn.selectize.support = originalSupport;
})(jQuery);
// #endregion

// #region Input Spinner
(function ($) {
    if (!$) {
        return;
    }

    $.fn.inputSpinner = (function () {
        const original = $.fn.inputSpinner;

        return function () {
            const args = arguments;

            this.each(function () {
                const $element = $(this);

                if ($element.closest(".input-spinner-container").length == 0) { // not initialized yet
                    $element.data("use-original-hide-show", true); // do not use the custom way of hiding the element (using the hidden attribute)

                    if ($element.attr("required")) {
                        $element.removeAttr("required");
                        $element.attr("data-rule-required", "true");
                    }

                    const result = original.apply($element, args);

                    const $associatedInput = $("input", $element.next());

                    $element.addClass("input-spinner-initialized");

                    const hasValidateRequired = $element.hasClass("validate-required");
                    if (hasValidateRequired) {
                        $element.removeClass("validate-required");
                    }

                    setTimeout(function () {
                        result.next().show();

                        if (hasValidateRequired) {
                            $associatedInput.attr("data-validate-required", true);
                        }
                    });

                    return result;
                }
            });

            return this;
        };
    })();
})(jQuery);
// #endregion
